import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import {
  addPresetAPI,
  addExtraPartRequestPartAPI,
  deletePresetAPI,
  generateMaintenanceTaskAPI,
  maintenanceAPI,
  MaintenanceDetailsAPI,
  presetByIdAPI,
  presetsAPI,
  updatePresetAPI,
  addPartAPI,
  getPartsAPI,
  deletePartAPI,
  updatePartAPI,
  extraPartRequestsAPI,
  analyticsAPI,
  updateTaskTimerUserSessionAPI,
  completeTaskUserSessionAPI,
  createPartRequestUserSessionAPI,
} from "../../routes/BackendRoutes";


export const fetchPresets = createAsyncThunk("fetch-presets", async () => {
  try {
    const response = await API_REQUEST({
      url: presetsAPI,
      method: "GET",
      isErrorToast: false,
    });
    return response;
  } catch (error) {
    console.log("error");
  }
});

export const deletePreset = createAsyncThunk("delete-preset", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: deletePresetAPI + payload,
      method: "DELETE",
    });
    callback(response);
    return response;
  } catch (error) {
    console.log(error);
  }
});

export const addPreset = createAsyncThunk("add-preset", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: addPresetAPI,
      method: "POST",
      data: payload,
    });
    callback?.(response);
    return response;
  } catch (error) {
    console.log(error);
  }
});

export const fetchPresetById = createAsyncThunk("fetch-preset-by-id", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: presetByIdAPI + payload,
      method: "GET",
      isErrorToast: false,
    });
    callback?.(response);
    return response;
  } catch (error) {
    console.log(error);
    callback?.(null, error);
  }
});

export const updatePreset = createAsyncThunk("update-preset", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updatePresetAPI,
      method: "PUT",
      data: payload,
    });
    callback?.(response);
    return response;
  } catch (error) {
    console.log(error);
  }
});

export const fetchMaintenance = createAsyncThunk("fetch-maintenance", async () => {
  try {
    const response = await API_REQUEST({
      url: maintenanceAPI,
      method: "GET",
      isErrorToast: false,
    });
    return response;
  } catch (error) {
    console.log("error");
  }
});

export const generateMaintenanceTask = createAsyncThunk("generate-maintenance-task", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: generateMaintenanceTaskAPI,
      method: "POST",
      data: payload,
    });
    callback?.(response);
    return response;
  } catch (error) {
    callback?.(null, error);
  }
});

export const fetchMaintenanceData = createAsyncThunk("maintenance-data", async (props) => {
  try {
    const { payload } = props;
    const response = await API_REQUEST({
      url: MaintenanceDetailsAPI + payload,
      method: "GET",
    });
    return response;
  } catch (error) {
    console.log(error);
  }
});

export const addPart = createAsyncThunk("add-part", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: addPartAPI,
      method: "POST",
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });
    callback?.(response);
    return response;
  } catch (error) {
    console.log(error);
    callback?.(null, error);
  }
});

export const fetchParts = createAsyncThunk(
  "fetch-parts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: getPartsAPI,
        method: "GET",
        isErrorToast: false,
      });
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchPartById = createAsyncThunk(
  "fetch-part-by-id",
  async (props, { rejectWithValue }) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: `${getPartsAPI}/${payload}`,
        method: "GET",
        isErrorToast: false,
      });
      callback?.(response);
      return response;
    } catch (error) {
      console.log(error);
      callback?.(null, error);
      return rejectWithValue(error);
    }
  }
);

export const deletePart = createAsyncThunk("delete-part", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: deletePartAPI + payload,
      method: "DELETE",
    });
    callback?.(response);
    return response;
  } catch (error) {
    console.log(error);
    callback?.(null, error);
  }
});

export const updatePart = createAsyncThunk("update-part", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updatePartAPI + payload?.id,
      method: "PUT",
      data: payload?.data,
      headers: {
        "Content-Type": "application/json",
      },
    });
    callback?.(response);
    return response;
  } catch (error) {
    console.log(error);
    callback?.(null, error);
  }
});

export const fetchExtraPartRequests = createAsyncThunk(
  "fetch-extra-part-requests",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: extraPartRequestsAPI,
        method: "GET",
        isErrorToast: false,
      });
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  },
);

export const acceptExtraPartRequest = createAsyncThunk(
  "accept-extra-part-request",
  async (props, { rejectWithValue }) => {
    const { payload, callback } = props;

    try {
      const response = await API_REQUEST({
        url: addExtraPartRequestPartAPI,
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      });
      callback?.(response);
      return response;
    } catch (error) {
      console.log(error);
      callback?.(null, error);
      return rejectWithValue(error);
    }
  },
);

export const fetchAnalytics = createAsyncThunk(
  "fetch-analytics",
  async (months = 1, { rejectWithValue }) => {
    try {
      const response = await API_REQUEST({
        url: `${analyticsAPI}?months=${months}`,
        method: "GET",
        isErrorToast: false,
      });

      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchSupplierMaintenance = createAsyncThunk("fetch-supplier-maintenance", async () => {
  try {
    const response = await API_REQUEST({
      url: `${maintenanceAPI}?view=supplier`,
      method: "GET",
      isErrorToast: false,
    });
    return response;
  } catch (error) {
    console.log("error");
  }
});

export const updateTaskTimerUserSession = createAsyncThunk("update-task-timer-user-session", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateTaskTimerUserSessionAPI,
      method: "POST",
      data: payload,
    });
    callback?.(response);
    return response;
  } catch (error) {
    callback?.(null, error);
  }
});

export const completeTaskUserSession = createAsyncThunk("complete-task-user-session", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: completeTaskUserSessionAPI,
      method: "POST",
      data: payload,
    });
    callback?.(response);
    return response;
  } catch (error) {
    callback?.(null, error);
  }
});

export const createPartRequestUserSession = createAsyncThunk("create-part-request-user-session", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: createPartRequestUserSessionAPI,
      method: "POST",
      data: payload,
    });
    callback?.(response);
    return response;
  } catch (error) {
    callback?.(null, error);
  }
});
